import { DerivedLocationSource } from 'graphql/bindings/AdminBindings'
import { getName } from 'country-list'

export const renderLocation = ({
  city,
  state,
  country,
  source,
}: {
  city?: string | null
  state?: string | null
  country?: string | null
  source?: DerivedLocationSource | null | undefined
}): string => {
  const countryName = country && getName(country)
  let locationString: string
  if (country === 'US' && city && state) {
    locationString = `${city}, ${state}`
  } else {
    locationString = [city, state, countryName].filter(v => v).join(', ')
  }
  switch (source) {
    case DerivedLocationSource.SignupLocation:
      return `${locationString} (platform signup location)`
    case DerivedLocationSource.EntityAddress:
      return `${locationString} (entity address)`
    default:
      return locationString
  }
}

export const getInitials = (name: string) => {
  return name
    .split(' ')
    .map(n => n[0])
    .join('')
    .substring(0, 2)
}

export const getHumanReadableSource = (source: string) => {
  switch (source) {
    case 'platform_user':
      return 'Platform'
    case 'crm_admin':
      return 'Market Console'
    default:
      return 'Unknown'
  }
}
